import { assortmentRoutes } from "@appretio/assortment";
import { inSeasonRoutes } from "@appretio/in-season";
import { lifecycleRoutes } from "@appretio/lifecycle-management";
import { preSeasonRoutes } from "@appretio/pre-season";
import { semanticThemeTokens } from "@appretio/ui-kit";
import { createBrowserRouter } from "react-router-dom";
import { AppLayout } from "./components/appLayout/AppLayout";
import { AuthGuard } from "./components/authGuard/AuthGuard";
import { LandingPage } from "./pages/landing-page/LandingPage";
import { LoginPage } from "./pages/login/LoginPage";

export const routes = [
  {
    element: <AuthGuard fallback={<LoginPage />} />,
    children: [
      {
        element: (
          <AppLayout
            navRoutes={[
              preSeasonRoutes,
              assortmentRoutes,
              inSeasonRoutes,
              lifecycleRoutes
            ]}
          />
        ),
        children: [
          {
            path: "/",
            index: true,
            element: <LandingPage />,
            handle: {
              background: semanticThemeTokens.backgroundGradient[1]
            }
          },
          preSeasonRoutes,
          assortmentRoutes,
          inSeasonRoutes,
          lifecycleRoutes
        ]
      }
    ]
  }
];

export const router = createBrowserRouter(routes);
